import api from './client.js'

export const programmeAPI = {
  list:   ()         => api.get('/programme'),
  getNow: ()         => api.get('/programme/now'),
  create: (data)     => api.post('/programme', data),
  update: (id, data) => api.patch(`/programme/${id}`, data),
  remove: (id)       => api.delete(`/programme/${id}`),
  clear:  ()         => api.post('/programme/clear'),
}
